const routerK = [{
    meta: { auth: true },
    path: '/textbookPromotion',
    name: '教材推广',
    component: () =>
        import ('@/components/goods/textbookPromotion')
}, ]
export default routerK


// WEBPACK FOOTER //
// ./src/router/routerK.js